var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 125,
    cy: 125,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 125,
    rx: 105,
    ry: 55
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 125,
    rx: 105,
    ry: 55,
    transform: "rotate(60 125 125)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125,
    cy: 125,
    rx: 105,
    ry: 55,
    transform: "rotate(120 125 125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.d3e7138229e3da3f7631016ae22aa922.svg";
export { ForwardRef as ReactComponent };